import React from 'react';

import { useTranslations } from 'utils';

function EURateDisclaimer() {
  const i18n = useTranslations();

  return (
    <p className="PaymentOptions-disclaimer">
      {i18n.t('paymentOptions.disclaimer')}
    </p>
  );
}

EURateDisclaimer.displayName = 'EURateDisclaimer';

export { EURateDisclaimer };
